import {Source} from "@amplitude/experiment-js-client";
import {experiment, initAll, setUserId} from "@amplitude/unified";
import type {UnifiedOptions} from "@amplitude/unified/lib/cjs/unified";

import {IAmplitudeExperimentVariants} from "../types/IAmplitudeExperimentVariants";
import {defaultAmplitudeLogger, IAmplitudeLogger} from "../types/IAmplitudeLogger";

let isAmplitudeInitialized = false;

interface IInitAmplitudeParams {
    amplitudeApiKey?: string;
    deploymentKey?: string;
    initialVariants?: IAmplitudeExperimentVariants;
    userId?: string;
    isBrowser?: boolean;
    logger?: IAmplitudeLogger;
}

export const initAmplitude = ({
    amplitudeApiKey,
    deploymentKey,
    initialVariants,
    userId,
    isBrowser = false,
    logger: _logger = defaultAmplitudeLogger
}: IInitAmplitudeParams): void => {
    if (!amplitudeApiKey) {
        // no key, silent exit
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && !isBrowser) {
        return;
    }

    // initialize only once
    if (isAmplitudeInitialized) {
        return;
    }

    const options: UnifiedOptions = {
        serverZone: "EU",
        analytics: {
            autocapture: true
        }
    };

    if (deploymentKey) {
        options.experiment = {
            deploymentKey,
            initialVariants: initialVariants ?? {},
            source: Source.InitialVariants
        };
    }

    initAll(amplitudeApiKey, options);

    if (userId) {
        setUserId(userId);
    }

    isAmplitudeInitialized = true;
};

export const setAmplitudeUserId = (userId: string | undefined): void => {
    if (isAmplitudeInitialized) {
        setUserId(userId);
    }
};

export {experiment};
import {Source} from "@amplitude/experiment-js-client";
import {experiment, initAll, setUserId} from "@amplitude/unified";
import type {UnifiedOptions} from "@amplitude/unified/lib/cjs/unified";

import {IAmplitudeExperimentVariants} from "../types/IAmplitudeExperimentVariants";
import {defaultAmplitudeLogger, IAmplitudeLogger} from "../types/IAmplitudeLogger";

let isAmplitudeInitialized = false;

interface IInitAmplitudeParams {
    amplitudeApiKey?: string;
    deploymentKey?: string;
    initialVariants?: IAmplitudeExperimentVariants;
    userId?: string;
    isBrowser?: boolean;
    logger?: IAmplitudeLogger;
}

export const initAmplitude = ({
    amplitudeApiKey,
    deploymentKey,
    initialVariants,
    userId,
    isBrowser = false,
    logger: _logger = defaultAmplitudeLogger
}: IInitAmplitudeParams): void => {
    if (!amplitudeApiKey) {
        // no key, silent exit
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && !isBrowser) {
        return;
    }

    // initialize only once
    if (isAmplitudeInitialized) {
        return;
    }

    const options: UnifiedOptions = {
        serverZone: "EU",
        analytics: {
            autocapture: true
        }
    };

    if (deploymentKey) {
        options.experiment = {
            deploymentKey,
            initialVariants: initialVariants ?? {},
            source: Source.InitialVariants
        };
    }

    initAll(amplitudeApiKey, options);

    if (userId) {
        setUserId(userId);
    }

    isAmplitudeInitialized = true;
};

export const setAmplitudeUserId = (userId: string | undefined): void => {
    if (isAmplitudeInitialized) {
        setUserId(userId);
    }
};

export {experiment};
